import httpClient from "@/api/httpClient";
import BookingCheckoutResponse from "@/model/BookingCheckoutResponse";
import BookingPage from "@/model/BookingPage";
import BookingResponse from "@/model/BookingResponse";
import CreateBookingRequest from "@/model/CreateBookingRequest";
import DeclineBookingRequest from "@/model/DeclineBookingRequest";

function listForProperty(
  accessToken: string,
  propertyId: string,
  page: number,
  size: number
): Promise<BookingPage> {
  return httpClient.getJson<BookingPage>(
    `/api/properties/${propertyId}/bookings?page=${page}&size=${size}`,
    accessToken
  );
}

function listForCompany(
  accessToken: string,
  companyId: string,
  page: number,
  size: number
): Promise<BookingPage> {
  return httpClient.getJson<BookingPage>(
    `/api/companies/${companyId}/bookings?page=${page}&size=${size}`,
    accessToken
  );
}

function createBooking(
  accessToken: string,
  request: CreateBookingRequest
): Promise<BookingCheckoutResponse> {
  return httpClient.postJson<BookingCheckoutResponse>(
    "/api/bookings",
    request,
    accessToken
  );
}

function cancelBooking(
  accessToken: string,
  id: string
): Promise<BookingResponse> {
  return httpClient.postJson<BookingResponse>(
    `/api/bookings/${id}/cancel`,
    {},
    accessToken
  );
}

function acceptBooking(accessToken: string, id: string): Promise<BookingResponse> {
  return httpClient.postJson<BookingResponse>(
    `/api/bookings/${id}/accept`,
    {},
    accessToken
  );
}

function declineBooking(
  accessToken: string,
  id: string,
  request: DeclineBookingRequest
): Promise<BookingResponse> {
  return httpClient.postJson<BookingResponse>(
    `/api/bookings/${id}/decline`,
    request,
    accessToken
  );
}

const bookingsApi = {
  listForProperty,
  listForCompany,
  createBooking,
  cancelBooking,
  acceptBooking,
  declineBooking,
};

export default bookingsApi;
